import React, { useState } from "react";
import { connect } from "react-redux";
import { updateEmployeeAuth } from "../../../actions/employeeAuthAction";
import { getAllEmployee } from "../../../actions/employeeAction";
import {
    Form,
    Input,
    Drawer,
    Button,
    Col,
    Row,
    Select,
    Checkbox,
} from "antd";
import { EditOutlined } from "@ant-design/icons";

const { Option } = Select;

const EditEmployeeAuth = ({
    updateEmployeeAuth,
    getAllEmployee,
    employees,
    id,
    initialValues,
    setUpdatelist,
}) => {
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const showDrawer = () => {
        getAllEmployee();
        setVisible(true);
        form.setFieldsValue({
            ...initialValues,
            pin: "" // Don't show hashed PIN, let them enter a new one if they want
        });
    };

    const onClose = () => {
        setVisible(false);
    };

    const onFinish = (values) => {
        // If PIN is empty, don't update it (backend needs to handle this or we omit it)
        const updatedValues = { ...values };
        if (!values.pin) {
            delete updatedValues.pin;
        }
        updateEmployeeAuth(id, updatedValues);
        setUpdatelist(false);
        setVisible(false);
    };

    return (
        <>
            <Button type="link" onClick={showDrawer} icon={<EditOutlined />}>
                Edit
            </Button>
            <Drawer
                title="Edit Employee PIN"
                width={400}
                onClose={onClose}
                visible={visible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="employee"
                                label="Employee"
                                rules={[{ required: true, message: "Please select an employee" }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select an employee"
                                    optionFilterProp="children"
                                    disabled
                                >
                                    {employees.map((emp) => (
                                        <Option key={emp.id} value={emp.id}>
                                            {emp.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="employee_name"
                                label="Display Name"
                                rules={[{ required: true, message: "Please enter employee name" }]}
                            >
                                <Input placeholder="Employee Name" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="pin"
                                label="New 6-Digit PIN (Leave empty to keep current)"
                                rules={[
                                    { len: 6, message: "PIN must be exactly 6 digits" }
                                ]}
                            >
                                <Input.Password maxLength={6} placeholder="Enter new 6-digit PIN" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="remarks" label="Remarks">
                                <Input.TextArea rows={2} placeholder="Optional remarks" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="is_admin" valuePropName="checked">
                                <Checkbox>Is Admin</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="is_staff" valuePropName="checked">
                                <Checkbox>Is Staff</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button onClick={onClose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        employees: state.employee.employeelist || [],
    };
};

export default connect(mapStateToProps, {
    updateEmployeeAuth,
    getAllEmployee,
})(EditEmployeeAuth);
